<!-- PRODUCTS EDITOR - Content Container -->
<div class="flex-1">
  <!-- RECOMMENDED PRODUCTS - Tablet Grid -->
  <div class="space-y-4">
    <!-- Toggle Recommendations -->
    @if (!showRecommendedShowcase) {
      <button
        (click)="showRecommendedShowcase = true"
        class="w-full py-3 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-slate-800 dark:to-slate-800 border-2 border-dashed border-blue-300 dark:border-blue-700 hover:border-blue-500 dark:hover:border-blue-400 rounded-xl text-sm font-medium text-blue-700 dark:text-blue-300 hover:text-blue-900 dark:hover:text-blue-200 transition-all flex items-center justify-center gap-2"
      >
        <span class="text-lg">✨</span>
        Produits recommandés ({{ recommendedCatalog.length }})
      </button>
    }

    <!-- Recommended Products Section -->
    @if (showRecommendedShowcase) {
      <section
        class="bg-white dark:bg-slate-800 rounded-xl shadow-sm dark:shadow-slate-900/30 border border-gray-200 dark:border-slate-700 overflow-hidden"
      >
        <!-- Section Header -->
        <div
          class="p-4 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-slate-700 dark:to-slate-700 border-b border-blue-100 dark:border-slate-600 flex items-center justify-between"
        >
          <div class="flex items-center gap-3">
            <span class="text-2xl">✨</span>
            <div>
              <h2 class="font-bold text-gray-900 dark:text-white">
                Produits recommandés pour vous
              </h2>
              <p class="text-xs text-gray-600 dark:text-gray-400">
                <span
                  class="px-2 py-0.5 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-full text-xs font-medium mr-2"
                >
                  {{ activityTypeLabels[activityType] }}
                </span>
                {{ recommendedCatalog.length }} produits
              </p>
            </div>
          </div>
          <div class="flex items-center gap-3">
            <!-- Bouton Tout ajouter -->
            <button
              (click)="addAllRecommendedProducts()"
              class="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium rounded-lg transition-all flex items-center gap-1.5 shadow-sm dark:shadow-slate-900/30"
              [disabled]="getNotAddedRecommendedCount() === 0"
              [class.opacity-50]="getNotAddedRecommendedCount() === 0"
              [class.cursor-not-allowed]="getNotAddedRecommendedCount() === 0"
            >
              <span>➕</span>
              Tout ajouter ({{ getNotAddedRecommendedCount() }})
            </button>
            <button
              (click)="showRecommendedShowcase = false"
              class="text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 dark:text-gray-300 underline"
            >
              Masquer
            </button>
          </div>
        </div>
        <!-- Products Grid - Compact responsive (mobile-first) -->
        <div
          class="p-3 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-6 gap-2"
        >
          @for (product of recommendedCatalog; track $index) {
            <button
              (click)="
                isProductAdded(product.name)
                  ? removeProductByName(product.name)
                  : addProductFromCatalog(product)
              "
              class="relative bg-white dark:bg-slate-800 rounded-lg p-2 border-2 transition-all duration-200 text-left group active:scale-95"
              [class.border-gray-200]="!isProductAdded(product.name)"
              [class.hover:border-blue-400]="!isProductAdded(product.name)"
              [class.hover:shadow-md]="!isProductAdded(product.name)"
              [class.border-green-400]="isProductAdded(product.name)"
              [class.bg-green-50]="isProductAdded(product.name)"
            >
              <!-- Product Icon -->
              <div class="text-3xl mb-1 text-center">
                {{ product.productIcon }}
              </div>
              <!-- Product Info -->
              <div class="text-center">
                <p
                  class="text-xs font-medium text-gray-900 dark:text-white truncate leading-tight"
                >
                  {{ product.name }}
                </p>
              </div>
              <!-- Badge popularité (compact) -->
              @if (
                product.popularity !== undefined &&
                product.popularity !== null &&
                product.popularity >= 9
              ) {
                <div
                  class="absolute top-0.5 right-0.5 text-xs"
                  [title]="'Popularité: ' + product.popularity + '/10'"
                >
                  🔥
                </div>
              }
              @if (
                product.popularity !== undefined &&
                product.popularity !== null &&
                product.popularity >= 7 &&
                product.popularity < 9
              ) {
                <div
                  class="absolute top-0.5 right-0.5 text-[10px]"
                  [title]="'Popularité: ' + product.popularity + '/10'"
                >
                  ⭐⭐⭐
                </div>
              }
              @if (
                product.popularity !== undefined &&
                product.popularity !== null &&
                product.popularity >= 5 &&
                product.popularity < 7
              ) {
                <div
                  class="absolute top-0.5 right-0.5 text-[10px]"
                  [title]="'Popularité: ' + product.popularity + '/10'"
                >
                  ⭐⭐
                </div>
              }
              @if (
                product.popularity !== undefined &&
                product.popularity !== null &&
                product.popularity >= 3 &&
                product.popularity < 5
              ) {
                <div
                  class="absolute top-0.5 right-0.5 text-[10px]"
                  [title]="'Popularité: ' + product.popularity + '/10'"
                >
                  ⭐
                </div>
              }
              <!-- État ajouté/non ajouté -->
              <div
                class="absolute bottom-1 right-1 w-4 h-4 flex items-center justify-center rounded-full text-[10px]"
                [class.bg-green-500]="isProductAdded(product.name)"
                [class.text-white]="isProductAdded(product.name)"
                [class.bg-gray-200]="!isProductAdded(product.name)"
                [class.text-gray-500]="!isProductAdded(product.name)"
              >
                {{ isProductAdded(product.name) ? "✓" : "+" }}
              </div>
            </button>
          }
        </div>
      </section>
    }

    <!-- Catalogue Slide-Over Panel -->
    @if (showSearchCatalog || showCatalogSearch()) {
      <div class="fixed inset-0 z-[10000] flex justify-end">
        <!-- Backdrop -->
        <div
          class="absolute inset-0 bg-black/40 backdrop-blur-sm"
          (click)="showSearchCatalog = false; closeCatalog.emit()"
        ></div>
        <!-- Panel - 70% on tablet, full on mobile -->
        <div
          class="relative w-full sm:w-[70%] lg:w-[50%] max-w-2xl bg-white dark:bg-slate-800 shadow-2xl animate-slide-in-right overflow-hidden flex flex-col"
        >
          <!-- Header -->
          <div
            class="sticky top-0 bg-white dark:bg-slate-800 border-b border-gray-200 dark:border-slate-700 p-4 flex items-center justify-between z-10"
          >
            <div class="flex items-center gap-3">
              <span class="text-2xl">📂</span>
              <div>
                <h2 class="font-bold text-gray-900 dark:text-white">
                  Catalogue complet
                </h2>
                <p class="text-xs text-gray-500 dark:text-gray-400">
                  Recherchez et ajoutez des produits
                </p>
              </div>
            </div>
            <button
              (click)="showSearchCatalog = false; closeCatalog.emit()"
              class="p-2 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 rounded-lg transition-colors"
            >
              <svg
                class="w-5 h-5 text-gray-500 dark:text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <!-- Search & Filters -->
          <div
            class="p-4 bg-gray-50 dark:bg-slate-900 border-b border-gray-200 dark:border-slate-700 space-y-3"
          >
            <div class="relative">
              <svg
                class="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
              <input
                type="text"
                [(ngModel)]="searchTerm"
                (ngModelChange)="onSearchChange($event)"
                placeholder="Rechercher un produit..."
                class="w-full pl-10 pr-4 py-3 border border-gray-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent text-base"
              />
            </div>
            <!-- Toggle Catalogue étendu -->
            <div class="flex items-center justify-between">
              <label class="flex items-center gap-2 cursor-pointer select-none">
                <input
                  type="checkbox"
                  [(ngModel)]="showExtendedCatalog"
                  (ngModelChange)="toggleExtendedCatalog()"
                  class="sr-only"
                />
                <div
                  class="relative w-10 h-5 rounded-full transition-colors"
                  [class.bg-purple-600]="showExtendedCatalog"
                  [class.bg-gray-300]="!showExtendedCatalog"
                >
                  <div
                    class="absolute top-0.5 left-0.5 w-4 h-4 bg-white dark:bg-slate-800 rounded-full transition-transform shadow"
                    [class.translate-x-5]="showExtendedCatalog"
                  ></div>
                </div>
                <span
                  class="text-sm font-medium"
                  [class.text-purple-700]="showExtendedCatalog"
                  [class.text-gray-600]="!showExtendedCatalog"
                >
                  🌍 Catalogue étendu
                </span>
              </label>
              <span class="text-xs text-gray-500 dark:text-gray-400">
                {{
                  showExtendedCatalog
                    ? universalCatalog.length
                    : fullCatalog.length
                }}
                produits
              </span>
            </div>
            <div class="flex gap-2 overflow-x-auto pb-1">
              <button
                (click)="onCategoryChange('all')"
                class="flex-shrink-0 px-3 py-1.5 rounded-full text-sm font-medium transition-colors"
                [class.bg-blue-600]="selectedCategory === 'all'"
                [class.text-white]="selectedCategory === 'all'"
                [class.bg-gray-100]="selectedCategory !== 'all'"
                [class.text-gray-700]="selectedCategory !== 'all'"
              >
                Tous
              </button>
              @for (cat of categories; track cat.name) {
                <button
                  (click)="onCategoryChange(cat.name)"
                  class="flex-shrink-0 px-3 py-1.5 rounded-full text-sm font-medium transition-colors flex items-center gap-1"
                  [class.bg-blue-600]="selectedCategory === cat.name"
                  [class.text-white]="selectedCategory === cat.name"
                  [class.bg-gray-100]="selectedCategory !== cat.name"
                  [class.text-gray-700]="selectedCategory !== cat.name"
                >
                  <span>{{ cat.icon }}</span>
                  {{ cat.name }}
                </button>
              }
            </div>
          </div>
          <!-- Results -->
          <div class="flex-1 overflow-y-auto p-4">
            @if (isSearching) {
              <div class="flex items-center justify-center py-12">
                <div
                  class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
                ></div>
              </div>
            }
            @if (filteredCatalog) {
              <div>
                <p class="text-sm text-gray-500 dark:text-gray-400 mb-3">
                  {{ filteredCatalog.length }} produit(s) trouvé(s)
                </p>
                @if (filteredCatalog.length === 0) {
                  <div
                    class="text-center py-12 text-gray-500 dark:text-gray-400"
                  >
                    <div class="text-5xl mb-3">🔍</div>
                    <p class="font-medium">Aucun produit trouvé</p>
                    <p class="text-sm mt-1">Essayez avec d'autres termes</p>
                  </div>
                }
                <div class="grid grid-cols-3 sm:grid-cols-4 gap-2">
                  @for (product of filteredCatalog; track $index) {
                    <button
                      (click)="
                        isProductAdded(product.name)
                          ? removeProductByName(product.name)
                          : addProductFromCatalog(product)
                      "
                      class="relative bg-white dark:bg-slate-800 rounded-lg p-2 border-2 transition-all duration-200 text-left active:scale-95"
                      [class.border-gray-200]="!isProductAdded(product.name)"
                      [class.hover:border-blue-400]="
                        !isProductAdded(product.name)
                      "
                      [class.border-green-400]="isProductAdded(product.name)"
                      [class.bg-green-50]="isProductAdded(product.name)"
                    >
                      <div class="text-3xl mb-1 text-center">
                        {{ product.productIcon }}
                      </div>
                      <p
                        class="text-xs font-medium text-gray-900 dark:text-white truncate text-center leading-tight"
                      >
                        {{ product.name }}
                      </p>
                      <!-- Badge popularité (compact) -->
                      @if (
                        product.popularity !== undefined &&
                        product.popularity !== null &&
                        product.popularity >= 9
                      ) {
                        <div
                          class="absolute top-0.5 right-0.5 text-xs"
                          [title]="'Popularité: ' + product.popularity + '/10'"
                        >
                          🔥
                        </div>
                      }
                      @if (
                        product.popularity !== undefined &&
                        product.popularity !== null &&
                        product.popularity >= 7 &&
                        product.popularity < 9
                      ) {
                        <div
                          class="absolute top-0.5 right-0.5 text-[10px]"
                          [title]="'Popularité: ' + product.popularity + '/10'"
                        >
                          ⭐⭐⭐
                        </div>
                      }
                      @if (
                        product.popularity !== undefined &&
                        product.popularity !== null &&
                        product.popularity >= 5 &&
                        product.popularity < 7
                      ) {
                        <div
                          class="absolute top-0.5 right-0.5 text-[10px]"
                          [title]="'Popularité: ' + product.popularity + '/10'"
                        >
                          ⭐⭐
                        </div>
                      }
                      @if (
                        product.popularity !== undefined &&
                        product.popularity !== null &&
                        product.popularity >= 3 &&
                        product.popularity < 5
                      ) {
                        <div
                          class="absolute top-0.5 right-0.5 text-[10px]"
                          [title]="'Popularité: ' + product.popularity + '/10'"
                        >
                          ⭐
                        </div>
                      }
                      <!-- État ajouté/non ajouté -->
                      <div
                        class="absolute bottom-1 right-1 w-4 h-4 flex items-center justify-center rounded-full text-[10px]"
                        [class.bg-green-500]="isProductAdded(product.name)"
                        [class.text-white]="isProductAdded(product.name)"
                        [class.bg-gray-200]="!isProductAdded(product.name)"
                        [class.text-gray-500]="!isProductAdded(product.name)"
                      >
                        {{ isProductAdded(product.name) ? "✓" : "+" }}
                      </div>
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>

  <!-- ACTION BUTTONS - Add Products Section -->
  <div
    class="mt-4 p-4 bg-white dark:bg-slate-800 rounded-xl shadow-sm dark:shadow-slate-900/30 border border-gray-200 dark:border-slate-700"
  >
    <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
      <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-300">
        Ajouter des produits :
      </h2>
      <div class="flex flex-wrap gap-2">
        <button
          (click)="openAddCustomProductModal()"
          class="flex items-center gap-2 px-4 py-2.5 bg-green-600 hover:bg-green-700 text-white rounded-lg text-sm font-medium transition-colors shadow-sm dark:shadow-slate-900/30"
        >
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 4v16m8-8H4"
            ></path>
          </svg>
          Produit personnalisé
        </button>
        <button
          (click)="showSearchCatalog = !showSearchCatalog"
          class="flex items-center gap-2 px-4 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-medium transition-colors shadow-sm dark:shadow-slate-900/30"
        >
          <span>📂</span>
          {{ showSearchCatalog ? "Fermer catalogue" : "Catalogue complet" }}
        </button>
        <button
          (click)="showTemplatePicker = !showTemplatePicker"
          class="flex items-center gap-2 px-4 py-2.5 bg-gradient-to-r from-purple-500 to-indigo-500 hover:from-purple-600 hover:to-indigo-600 text-white rounded-lg text-sm font-medium transition-all shadow-sm"
        >
          <span>📋</span>
          {{ showTemplatePicker ? "Fermer templates" : "Templates" }}
        </button>
      </div>
    </div>
  </div>

  <!-- MES PRODUITS - Tablet Optimized Grid -->
  <section
    class="mt-4 bg-white dark:bg-slate-800 rounded-xl shadow-sm dark:shadow-slate-900/30 border border-gray-200 dark:border-slate-700 overflow-hidden"
    [class.border-green-300]="myProducts.length >= 3"
  >
    <!-- Section Header avec Filtres -->
    <div class="p-4 border-b border-gray-100 dark:border-slate-700">
      <div class="flex items-center justify-between mb-3">
        <div class="flex items-center gap-3">
          <span class="text-2xl">📋</span>
          <div>
            <h2 class="font-bold text-gray-900 dark:text-white">
              Mes produits
            </h2>
            @if (myProducts.length >= 3) {
              <p class="text-xs text-gray-500 dark:text-gray-400">
                Cliquez sur un produit pour l'éditer
              </p>
            }
            @if (myProducts.length < 3) {
              <p class="text-xs text-orange-600 font-medium">
                ⚠️ Sélectionnez au moins 3 produits pour continuer
              </p>
            }
          </div>
        </div>
        <div class="flex items-center gap-2">
          @if (myProducts.length > 0) {
            <button
              (click)="deleteAllProducts()"
              class="px-2 py-1 text-xs font-medium text-red-600 bg-red-50 hover:bg-red-100 rounded-lg transition-colors"
              title="Supprimer tous les produits"
            >
              🗑️ Tout supprimer
            </button>
          }
          <span
            class="px-3 py-1.5 rounded-full text-sm font-semibold"
            [class.bg-green-100]="myProducts.length >= 3"
            [class.text-green-700]="myProducts.length >= 3"
            [class.bg-orange-100]="myProducts.length < 3"
            [class.text-orange-700]="myProducts.length < 3"
          >
            {{ myProducts.length }} produit{{
              myProducts.length > 1 ? "s" : ""
            }}
          </span>
        </div>
      </div>

      <!-- KPI Stats Bar (optionnel) -->
      @if (showStats()) {
        <div
          class="flex items-center gap-4 md:gap-6 overflow-x-auto py-2 mb-3 border-b border-gray-100 dark:border-slate-700"
        >
          <div class="flex items-center gap-2 text-sm whitespace-nowrap">
            <span class="text-gray-500 dark:text-gray-400">Stock achat</span>
            <span class="font-bold text-orange-600"
              >{{ totalStockPurchaseValue() | number: "1.0-0" }}€</span
            >
          </div>
          <div class="w-px h-4 bg-gray-300"></div>
          <div class="flex items-center gap-2 text-sm whitespace-nowrap">
            <span class="text-gray-500 dark:text-gray-400">Stock vente</span>
            <span class="font-bold text-green-600 dark:text-green-400"
              >{{ totalStockSellValue() | number: "1.0-0" }}€</span
            >
          </div>
          @if (productsAtRisk() > 0) {
            <div class="w-px h-4 bg-gray-300"></div>
          }
          @if (productsAtRisk() > 0) {
            <button
              (click)="
                myProductsFilter.risk =
                  myProductsFilter.risk === 'any' ? 'all' : 'any';
                showFilters = true
              "
              class="flex items-center gap-2 text-sm whitespace-nowrap px-2 py-1 rounded-lg transition-colors"
              [class.bg-red-100]="myProductsFilter.risk === 'any'"
              [class.hover:bg-red-50]="myProductsFilter.risk !== 'any'"
              title="Cliquez pour filtrer les produits à risque"
            >
              <span class="text-gray-500 dark:text-gray-400">⚠️ À risque</span>
              <span class="font-bold text-red-600 dark:text-red-400">{{
                productsAtRisk()
              }}</span>
            </button>
          }
          <!-- Auto-save indicator -->
          @if (autoSaving()) {
            <span class="ml-auto text-xs text-gray-400 flex items-center gap-1">
              <svg class="w-3 h-3 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                ></path>
              </svg>
              Sauvegarde...
            </span>
          }
        </div>
      }

      <!-- Barre de filtres PRO -->
      @if (myProducts.length > 0) {
        <div class="space-y-3">
          <!-- Ligne 1: Recherche + Toggle filtres -->
          <div class="flex items-center gap-2">
            <!-- Recherche rapide -->
            <div class="flex-1 relative">
              <svg
                class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
              <input
                type="text"
                [(ngModel)]="myProductsFilter.search"
                placeholder="Rechercher..."
                class="w-full pl-9 pr-4 py-2 text-sm bg-gray-50 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              />
              @if (myProductsFilter.search) {
                <button
                  (click)="myProductsFilter.search = ''"
                  class="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-gray-200 dark:hover:bg-slate-600 dark:bg-slate-700 rounded-full"
                >
                  <svg
                    class="w-3 h-3 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              }
            </div>
            <!-- Bouton Filtres -->
            <button
              (click)="toggleFilters()"
              class="flex items-center gap-2 px-3 py-2 text-sm font-medium rounded-lg transition-all"
              [class.bg-blue-100]="showFilters || hasActiveFilters"
              [class.text-blue-700]="showFilters || hasActiveFilters"
              [class.bg-gray-100]="!showFilters && !hasActiveFilters"
              [class.text-gray-600]="!showFilters && !hasActiveFilters"
              [class.hover:bg-gray-200]="!showFilters && !hasActiveFilters"
            >
              <svg
                class="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                />
              </svg>
              <span>Filtres</span>
              @if (hasActiveFilters) {
                <span class="w-2 h-2 bg-blue-500 rounded-full"></span>
              }
            </button>
            <!-- Tri rapide -->
            <div class="relative">
              <select
                [(ngModel)]="myProductsFilter.sortBy"
                class="appearance-none pl-3 pr-8 py-2 text-sm bg-gray-50 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-blue-500 cursor-pointer"
              >
                <option value="name">A-Z</option>
                <option value="price">Prix</option>
                <option value="popularity">Popularité</option>
                <option value="margin">Marge</option>
              </select>
              <svg
                class="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
            <!-- Toggle ordre -->
            <button
              (click)="
                myProductsFilter.sortOrder =
                  myProductsFilter.sortOrder === 'asc' ? 'desc' : 'asc'
              "
              class="p-2 bg-gray-50 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 transition-colors"
              [title]="
                myProductsFilter.sortOrder === 'asc'
                  ? 'Ordre croissant'
                  : 'Ordre décroissant'
              "
            >
              <svg
                class="w-4 h-4 text-gray-600 dark:text-gray-400 transition-transform"
                [class.rotate-180]="myProductsFilter.sortOrder === 'desc'"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
                />
              </svg>
            </button>
          </div>
          <!-- Ligne 2: Filtres avancés (collapsible) -->
          @if (showFilters) {
            <div
              class="flex flex-wrap items-center gap-2 pt-2 border-t border-gray-100 dark:border-slate-700 animate-fade-in"
            >
              <!-- Filtre Popularité -->
              <div class="flex items-center gap-1">
                <span class="text-xs text-gray-500 dark:text-gray-400 mr-1"
                  >Popularité:</span
                >
                <button
                  (click)="myProductsFilter.popularity = 'all'"
                  class="px-2.5 py-1 text-xs font-medium rounded-full transition-all"
                  [class.bg-gray-900]="myProductsFilter.popularity === 'all'"
                  [class.text-white]="myProductsFilter.popularity === 'all'"
                  [class.bg-gray-100]="myProductsFilter.popularity !== 'all'"
                  [class.text-gray-600]="myProductsFilter.popularity !== 'all'"
                  [class.hover:bg-gray-200]="
                    myProductsFilter.popularity !== 'all'
                  "
                >
                  Tous
                </button>
                <button
                  (click)="myProductsFilter.popularity = 'high'"
                  class="px-2.5 py-1 text-xs font-medium rounded-full transition-all"
                  [class.bg-orange-500]="myProductsFilter.popularity === 'high'"
                  [class.text-white]="myProductsFilter.popularity === 'high'"
                  [class.bg-orange-100]="myProductsFilter.popularity !== 'high'"
                  [class.text-orange-700]="
                    myProductsFilter.popularity !== 'high'
                  "
                  [class.hover:bg-orange-200]="
                    myProductsFilter.popularity !== 'high'
                  "
                >
                  🔥 9-10
                </button>
                <button
                  (click)="myProductsFilter.popularity = 'medium'"
                  class="px-2.5 py-1 text-xs font-medium rounded-full transition-all"
                  [class.bg-yellow-500]="
                    myProductsFilter.popularity === 'medium'
                  "
                  [class.text-white]="myProductsFilter.popularity === 'medium'"
                  [class.bg-yellow-100]="
                    myProductsFilter.popularity !== 'medium'
                  "
                  [class.text-yellow-700]="
                    myProductsFilter.popularity !== 'medium'
                  "
                  [class.hover:bg-yellow-200]="
                    myProductsFilter.popularity !== 'medium'
                  "
                >
                  ⭐ 5-8
                </button>
                <button
                  (click)="myProductsFilter.popularity = 'low'"
                  class="px-2.5 py-1 text-xs font-medium rounded-full transition-all"
                  [class.bg-gray-500]="myProductsFilter.popularity === 'low'"
                  [class.text-white]="myProductsFilter.popularity === 'low'"
                  [class.bg-gray-100]="myProductsFilter.popularity !== 'low'"
                  [class.text-gray-600]="myProductsFilter.popularity !== 'low'"
                  [class.hover:bg-gray-200]="
                    myProductsFilter.popularity !== 'low'
                  "
                >
                  ⭐ 1-4
                </button>
              </div>
              <div class="w-px h-5 bg-gray-200 dark:bg-slate-700"></div>
              <!-- Filtre Type -->
              <div class="flex items-center gap-1">
                <span class="text-xs text-gray-500 dark:text-gray-400 mr-1"
                  >Type:</span
                >
                <button
                  (click)="myProductsFilter.type = 'all'"
                  class="px-2.5 py-1 text-xs font-medium rounded-full transition-all"
                  [class.bg-gray-900]="myProductsFilter.type === 'all'"
                  [class.text-white]="myProductsFilter.type === 'all'"
                  [class.bg-gray-100]="myProductsFilter.type !== 'all'"
                  [class.text-gray-600]="myProductsFilter.type !== 'all'"
                  [class.hover:bg-gray-200]="myProductsFilter.type !== 'all'"
                >
                  Tous
                </button>
                <button
                  (click)="myProductsFilter.type = 'custom'"
                  class="px-2.5 py-1 text-xs font-medium rounded-full transition-all"
                  [class.bg-purple-500]="myProductsFilter.type === 'custom'"
                  [class.text-white]="myProductsFilter.type === 'custom'"
                  [class.bg-purple-100]="myProductsFilter.type !== 'custom'"
                  [class.text-purple-700]="myProductsFilter.type !== 'custom'"
                  [class.hover:bg-purple-200]="
                    myProductsFilter.type !== 'custom'
                  "
                >
                  ✏️ Perso
                </button>
                <button
                  (click)="myProductsFilter.type = 'ai'"
                  class="px-2.5 py-1 text-xs font-medium rounded-full transition-all"
                  [class.bg-blue-500]="myProductsFilter.type === 'ai'"
                  [class.text-white]="myProductsFilter.type === 'ai'"
                  [class.bg-blue-100]="myProductsFilter.type !== 'ai'"
                  [class.text-blue-700]="myProductsFilter.type !== 'ai'"
                  [class.hover:bg-blue-200]="myProductsFilter.type !== 'ai'"
                >
                  🤖 IA
                </button>
              </div>
              <div class="w-px h-5 bg-gray-200 dark:bg-slate-700"></div>
              <!-- Filtre Source -->
              <div class="flex items-center gap-1">
                <span class="text-xs text-gray-500 dark:text-gray-400 mr-1"
                  >Source:</span
                >
                <button
                  (click)="myProductsFilter.source = 'all'"
                  class="px-2.5 py-1 text-xs font-medium rounded-full transition-all"
                  [class.bg-gray-900]="myProductsFilter.source === 'all'"
                  [class.text-white]="myProductsFilter.source === 'all'"
                  [class.bg-gray-100]="myProductsFilter.source !== 'all'"
                  [class.text-gray-600]="myProductsFilter.source !== 'all'"
                  [class.hover:bg-gray-200]="myProductsFilter.source !== 'all'"
                >
                  Tous
                </button>
                <button
                  (click)="myProductsFilter.source = 'core'"
                  class="px-2.5 py-1 text-xs font-medium rounded-full transition-all"
                  [class.bg-green-500]="myProductsFilter.source === 'core'"
                  [class.text-white]="myProductsFilter.source === 'core'"
                  [class.bg-green-100]="myProductsFilter.source !== 'core'"
                  [class.text-green-700]="myProductsFilter.source !== 'core'"
                  [class.hover:bg-green-200]="
                    myProductsFilter.source !== 'core'
                  "
                  title="Produits de votre activité principale"
                >
                  🎯 Cœur ({{ coreProductsCount }})
                </button>
                <button
                  (click)="myProductsFilter.source = 'extended'"
                  class="px-2.5 py-1 text-xs font-medium rounded-full transition-all"
                  [class.bg-purple-500]="myProductsFilter.source === 'extended'"
                  [class.text-white]="myProductsFilter.source === 'extended'"
                  [class.bg-purple-100]="myProductsFilter.source !== 'extended'"
                  [class.text-purple-700]="
                    myProductsFilter.source !== 'extended'
                  "
                  [class.hover:bg-purple-200]="
                    myProductsFilter.source !== 'extended'
                  "
                  title="Produits du catalogue étendu"
                >
                  🌍 Étendu ({{ extendedProductsCount }})
                </button>
                <button
                  (click)="myProductsFilter.source = 'custom'"
                  class="px-2.5 py-1 text-xs font-medium rounded-full transition-all"
                  [class.bg-indigo-500]="myProductsFilter.source === 'custom'"
                  [class.text-white]="myProductsFilter.source === 'custom'"
                  [class.bg-indigo-100]="myProductsFilter.source !== 'custom'"
                  [class.text-indigo-700]="myProductsFilter.source !== 'custom'"
                  [class.hover:bg-indigo-200]="
                    myProductsFilter.source !== 'custom'
                  "
                  title="Produits personnalisés"
                >
                  ✨ Perso ({{ customProductsCount }})
                </button>
              </div>
              <div class="w-px h-5 bg-gray-200 dark:bg-slate-700"></div>
              <!-- Filtre Risque -->
              <div class="flex items-center gap-1">
                <span class="text-xs text-gray-500 dark:text-gray-400 mr-1"
                  >Risque:</span
                >
                <button
                  (click)="myProductsFilter.risk = 'all'"
                  class="px-2.5 py-1 text-xs font-medium rounded-full transition-all"
                  [class.bg-gray-900]="myProductsFilter.risk === 'all'"
                  [class.text-white]="myProductsFilter.risk === 'all'"
                  [class.bg-gray-100]="myProductsFilter.risk !== 'all'"
                  [class.text-gray-600]="myProductsFilter.risk !== 'all'"
                  [class.hover:bg-gray-200]="myProductsFilter.risk !== 'all'"
                >
                  Tous
                </button>
                <button
                  (click)="myProductsFilter.risk = 'any'"
                  class="px-2.5 py-1 text-xs font-medium rounded-full transition-all"
                  [class.bg-red-500]="myProductsFilter.risk === 'any'"
                  [class.text-white]="myProductsFilter.risk === 'any'"
                  [class.bg-red-100]="myProductsFilter.risk !== 'any'"
                  [class.text-red-700]="myProductsFilter.risk !== 'any'"
                  [class.hover:bg-red-200]="myProductsFilter.risk !== 'any'"
                >
                  ⚠️ À risque
                </button>
                <button
                  (click)="myProductsFilter.risk = 'rupture'"
                  class="px-2.5 py-1 text-xs font-medium rounded-full transition-all"
                  [class.bg-orange-500]="myProductsFilter.risk === 'rupture'"
                  [class.text-white]="myProductsFilter.risk === 'rupture'"
                  [class.bg-orange-100]="myProductsFilter.risk !== 'rupture'"
                  [class.text-orange-700]="myProductsFilter.risk !== 'rupture'"
                  [class.hover:bg-orange-200]="
                    myProductsFilter.risk !== 'rupture'
                  "
                >
                  🚨 Rupture
                </button>
                <button
                  (click)="myProductsFilter.risk = 'surstock'"
                  class="px-2.5 py-1 text-xs font-medium rounded-full transition-all"
                  [class.bg-amber-500]="myProductsFilter.risk === 'surstock'"
                  [class.text-white]="myProductsFilter.risk === 'surstock'"
                  [class.bg-amber-100]="myProductsFilter.risk !== 'surstock'"
                  [class.text-amber-700]="myProductsFilter.risk !== 'surstock'"
                  [class.hover:bg-amber-200]="
                    myProductsFilter.risk !== 'surstock'
                  "
                >
                  📦 Surstock
                </button>
              </div>
              <!-- Reset -->
              @if (hasActiveFilters) {
                <button
                  (click)="resetMyProductsFilters()"
                  class="ml-auto px-2.5 py-1 text-xs font-medium text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:bg-red-900/30 rounded-full transition-all flex items-center gap-1"
                >
                  <svg
                    class="w-3 h-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                  Réinitialiser
                </button>
              }
            </div>
          }
        </div>
      }
    </div>

    <!-- Empty State -->
    @if (myProducts.length === 0) {
      <div class="p-8 text-center text-gray-500 dark:text-gray-400">
        <div class="text-6xl mb-4">📦</div>
        <p class="font-medium text-gray-700 dark:text-gray-300">
          Aucun produit sélectionné
        </p>
        <p class="text-sm mt-1">
          Ajoutez des produits depuis les recommandations ci-dessus
        </p>
      </div>
    }

    <!-- No results after filter -->
    @if (myProducts.length > 0 && filteredMyProducts.length === 0) {
      <div class="p-8 text-center text-gray-500 dark:text-gray-400">
        <div class="text-4xl mb-3">🔍</div>
        <p class="font-medium text-gray-700 dark:text-gray-300">
          Aucun produit trouvé
        </p>
        <p class="text-sm mt-1">Essayez de modifier vos filtres</p>
        <button
          (click)="resetMyProductsFilters()"
          class="mt-3 px-4 py-2 text-sm font-medium text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20 hover:bg-blue-100 dark:bg-blue-900/30 rounded-lg transition-colors"
        >
          Réinitialiser les filtres
        </button>
      </div>
    }

    <!-- Products Grid - Tablet Touch-Friendly -->
    @if (filteredMyProducts.length > 0) {
      <div
        class="p-4 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 gap-2"
        [class.2xl:grid-cols-9]="!isOnboarding()"
      >
        @for (
          product of filteredMyProducts;
          track trackByProductId($index, product)
        ) {
          <div
            (click)="selectProduct(product)"
            class="relative bg-white dark:bg-slate-800 rounded-xl p-1.5 border-2 hover:shadow-lg dark:shadow-slate-900/50 transition-all duration-200 cursor-pointer group"
            [class.border-gray-200]="
              !product.riskType && selectedProduct?.id !== product.id
            "
            [class.hover:border-blue-400]="!product.riskType"
            [class.border-red-400]="product.riskType === 'rupture'"
            [class.bg-red-50]="product.riskType === 'rupture'"
            [class.border-amber-400]="product.riskType === 'surstock'"
            [class.bg-amber-50]="product.riskType === 'surstock'"
            [class.ring-2]="selectedProduct?.id === product.id"
            [class.ring-blue-500]="selectedProduct?.id === product.id"
            [class.border-blue-400]="selectedProduct?.id === product.id"
          >
            <!-- Remove Button -->
            <button
              (click)="removeProduct(product.id); $event.stopPropagation()"
              class="absolute -top-2 -right-2 w-7 h-7 bg-red-500 hover:bg-red-600 text-white rounded-full shadow-md dark:shadow-slate-900/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center z-10"
              title="Retirer"
            >
              <svg
                class="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <!-- Suggestions IA Badge -->
            @if (hasSuggestions(product)) {
              <div class="absolute -top-2 -left-2 z-10 group/tip">
                <button
                  (click)="$event.stopPropagation()"
                  class="w-7 h-7 bg-amber-500 hover:bg-amber-600 text-white rounded-full shadow-md dark:shadow-slate-900/50 flex items-center justify-center transition-colors"
                  title="Suggestions IA"
                >
                  💡
                </button>
                <!-- Tooltip avec les suggestions -->
                <div
                  class="absolute left-0 top-8 w-64 bg-white dark:bg-slate-800 rounded-xl shadow-2xl border border-gray-200 dark:border-slate-700 p-3 opacity-0 invisible group-hover/tip:opacity-100 group-hover/tip:visible transition-all z-50"
                >
                  <div
                    class="text-xs font-bold text-gray-900 dark:text-white mb-2 flex items-center gap-1"
                  >
                    <span>💡</span> Suggestions IA
                  </div>
                  <div class="space-y-2">
                    @for (s of getSuggestions(product); track $index) {
                      <div class="text-xs">
                        <p class="font-medium text-gray-700 dark:text-gray-300">
                          <span>{{ s.icon }}</span> {{ s.message }}
                        </p>
                        <p class="text-gray-500 dark:text-gray-400 ml-4">
                          {{ s.tip }}
                        </p>
                      </div>
                    }
                  </div>
                  <div
                    class="mt-2 pt-2 border-t border-gray-100 dark:border-slate-700"
                  >
                    <p class="text-[10px] text-gray-400 text-center">
                      Cliquez sur le produit pour modifier
                    </p>
                  </div>
                </div>
              </div>
            }
            <!-- Product Icon -->
            <div class="text-3xl text-center">{{ product.productIcon }}</div>
            <!-- Product Info -->
            <div class="text-center">
              <p
                class="text-xs font-semibold text-gray-900 dark:text-white truncate"
              >
                {{ product.name }}
              </p>
              <p class="text-[10px] text-gray-500 dark:text-gray-400 truncate">
                {{ product.category }}
              </p>
            </div>
            <!-- Prix achat/vente -->
            <div class="flex items-center justify-center gap-1 text-[10px]">
              <span class="text-gray-500 dark:text-gray-400"
                >Achat: {{ product.purchasePrice || 0 }}€</span
              >
              <span class="text-gray-400">|</span>
              <span class="font-semibold text-green-600 dark:text-green-400"
                >Vente: {{ product.sellPrice || 0 }}€</span
              >
            </div>
            <!-- Stock & Marge -->
            <div class="flex items-center justify-center gap-1 text-[10px]">
              <span class="text-gray-500 dark:text-gray-400"
                >Stock: {{ product.quantity }}</span
              >
              <span class="text-gray-400">|</span>
              <span class="font-medium text-gray-700 dark:text-gray-300"
                >Marge: {{ getMargin(product) }}%</span
              >
            </div>
            <!-- Badges (Popularité, Risques) -->
            <div class="flex items-center justify-center gap-0.5 flex-wrap">
              @if (product.popularity && product.popularity >= 9) {
                <span
                  class="text-[10px] px-1 py-0.5 bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300 rounded-full font-medium"
                  title="Très populaire"
                >
                  🔥 {{ product.popularity }}/10
                </span>
              }
              @if (
                product.popularity &&
                product.popularity >= 7 &&
                product.popularity < 9
              ) {
                <span
                  class="text-[10px] px-1 py-0.5 bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300 rounded-full font-medium"
                  title="Populaire"
                >
                  ⭐⭐⭐ {{ product.popularity }}/10
                </span>
              }
              @if (
                product.popularity &&
                product.popularity >= 5 &&
                product.popularity < 7
              ) {
                <span
                  class="text-[10px] px-1 py-0.5 bg-yellow-100 dark:bg-yellow-900/30 text-yellow-600 rounded-full font-medium"
                  title="Assez populaire"
                >
                  ⭐⭐ {{ product.popularity }}/10
                </span>
              }
              @if (
                product.popularity &&
                product.popularity >= 1 &&
                product.popularity < 5
              ) {
                <span
                  class="text-[10px] px-1 py-0.5 bg-gray-100 dark:bg-slate-800 text-gray-600 dark:text-gray-400 rounded-full font-medium"
                  title="Peu populaire"
                >
                  ⭐ {{ product.popularity }}/10
                </span>
              }
              @if (product.isCustom) {
                <span
                  class="text-[10px] px-1 py-0.5 bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 rounded-full font-medium"
                  title="Produit personnalisé"
                >
                  ✏️ Perso
                </span>
              }
              @if (product.isAISuggested) {
                <span
                  class="text-[10px] px-1 py-0.5 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-full font-medium"
                  title="Suggéré par l'IA"
                >
                  🤖 IA
                </span>
              }
              <!-- Badge Source: Cœur de métier -->
              @if (
                product.sourceType === "core" ||
                (!product.sourceType && !product.isCustom)
              ) {
                <span
                  class="text-[10px] px-1 py-0.5 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 rounded-full font-medium"
                  title="Produit de votre activité principale"
                >
                  🎯 Cœur
                </span>
              }
              <!-- Badge Source: Étendu -->
              @if (product.sourceType === "extended") {
                <span
                  class="text-[10px] px-1 py-0.5 bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 rounded-full font-medium"
                  title="Produit du catalogue étendu"
                >
                  🌍 Étendu
                </span>
              }
              <!-- Badge Source: Personnalisé -->
              @if (product.sourceType === "custom") {
                <span
                  class="text-[10px] px-1 py-0.5 bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 rounded-full font-medium"
                  title="Produit personnalisé"
                >
                  ✨ Perso
                </span>
              }
              <!-- Badge Risque Rupture -->
              @if (product.riskType === "rupture") {
                <span
                  class="text-[10px] px-1 py-0.5 bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 rounded-full font-medium animate-pulse"
                  title="Risque de rupture : stock faible + forte popularité"
                >
                  🚨 Rupture
                </span>
              }
              <!-- Badge Risque Surstock -->
              @if (product.riskType === "surstock") {
                <span
                  class="text-[10px] px-1 py-0.5 bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300 rounded-full font-medium"
                  title="Risque de surstock : quantité excessive"
                >
                  📦 Surstock
                </span>
              }
              <!-- Badge Périssabilité -->
              @if (product.perishability === "low") {
                <span
                  class="text-[10px] px-1 py-0.5 bg-sky-100 text-sky-600 rounded-full font-medium"
                  title="Non périssable — retour stock possible"
                >
                  🧊 Stock
                </span>
              } @else if (product.perishability === "medium") {
                <span
                  class="text-[10px] px-1 py-0.5 bg-amber-100 dark:bg-amber-900/30 text-amber-600 rounded-full font-medium"
                  title="Périssabilité moyenne (1-2 jours)"
                >
                  ⚠️ 1-2j
                </span>
              }
            </div>
          </div>
        }
      </div>
    }
  </section>

  <!-- Modal Produit Personnalisé - Version Pro -->
  @if (showCustomProductModal) {
    <div
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 animate-fade-in"
      (click)="closeAddCustomProductModal()"
    >
      <div
        class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] flex flex-col animate-scale-in"
        (click)="$event.stopPropagation()"
      >
        <!-- Header (fixe) -->
        <div
          class="flex-shrink-0 bg-gradient-to-r from-green-600 to-emerald-600 text-white p-6 rounded-t-2xl"
        >
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-3">
              <div
                class="w-12 h-12 bg-white dark:bg-slate-800 bg-opacity-20 rounded-xl flex items-center justify-center"
              >
                <span class="text-2xl">✨</span>
              </div>
              <div>
                <h3 class="text-xl font-bold">Créer un produit personnalisé</h3>
                <p class="text-sm text-green-100 mt-1">
                  Ajoutez un produit unique à votre catalogue
                </p>
              </div>
            </div>
            <button
              (click)="closeAddCustomProductModal()"
              class="w-10 h-10 bg-white dark:bg-slate-800 bg-opacity-20 hover:bg-opacity-30 rounded-lg transition-all flex items-center justify-center"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
        </div>
        <!-- Contenu scrollable -->
        <div class="flex-1 overflow-y-auto p-6">
          <!-- Preview Card -->
          @if (customProduct.name) {
            <div
              class="mb-6 bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-slate-800 dark:to-slate-800 rounded-xl p-5 border-2 border-blue-200 dark:border-blue-800"
            >
              <p
                class="text-xs font-semibold text-blue-900 dark:text-blue-300 uppercase tracking-wide mb-3"
              >
                Aperçu
              </p>
              <div
                class="bg-white dark:bg-slate-800 rounded-lg p-4 shadow-sm dark:shadow-slate-900/30"
              >
                <div class="flex items-center gap-4">
                  <div class="text-5xl">{{ customProduct.productIcon }}</div>
                  <div class="flex-1">
                    <div class="flex items-center gap-2 mb-1">
                      <h4
                        class="font-bold text-gray-900 dark:text-white text-lg"
                      >
                        {{ customProduct.name }}
                      </h4>
                      <span
                        class="text-xs bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 px-2 py-1 rounded-full font-medium"
                        >Personnalisé</span
                      >
                    </div>
                    <div
                      class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400"
                    >
                      <span>{{ customProduct.category || "Catégorie" }}</span>
                      <span class="text-gray-400">•</span>
                      <span class="font-medium"
                        >{{ customProduct.quantity }}
                        {{ customProduct.unit }}</span
                      >
                      <span class="text-gray-400">•</span>
                      <span class="text-orange-600"
                        >Achat: {{ customProduct.purchasePrice }}€</span
                      >
                      <span class="text-gray-400">•</span>
                      <span class="font-bold text-green-600 dark:text-green-400"
                        >Vente: {{ customProduct.sellPrice }}€</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          <!-- Formulaire -->
          <div class="space-y-6">
            <!-- Section 1: Informations de base -->
            <div>
              <h4
                class="text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wide mb-4 flex items-center gap-2"
              >
                <span
                  class="w-6 h-6 bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-full flex items-center justify-center text-xs"
                  >1</span
                >
                Informations de base
              </h4>
              <div class="space-y-4">
                <div>
                  <label
                    class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                  >
                    Nom du produit <span class="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    [(ngModel)]="customProduct.name"
                    placeholder="Ex: Tarte aux pommes maison, Pain spécial..."
                    class="w-full px-4 py-3 border-2 border-gray-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 dark:placeholder-gray-400"
                  />
                  <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                    Choisissez un nom clair et descriptif
                  </p>
                </div>
                <div>
                  <label
                    class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                  >
                    Catégorie <span class="text-red-500">*</span>
                  </label>
                  <div class="grid grid-cols-3 gap-2">
                    @for (cat of categories; track cat.name) {
                      <button
                        (click)="customProduct.category = cat.name"
                        [class.ring-2]="customProduct.category === cat.name"
                        [class.ring-green-500]="
                          customProduct.category === cat.name
                        "
                        [class.bg-green-50]="
                          customProduct.category === cat.name
                        "
                        class="p-3 border-2 border-gray-200 dark:border-slate-700 rounded-lg hover:border-green-300 transition-all text-center cursor-pointer"
                      >
                        <div class="text-2xl mb-1">{{ cat.icon }}</div>
                        <p
                          class="text-xs font-medium text-gray-900 dark:text-white"
                        >
                          {{ cat.name }}
                        </p>
                      </button>
                    }
                  </div>
                </div>
              </div>
            </div>
            <!-- Section 2: Icône -->
            <div>
              <h4
                class="text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wide mb-4 flex items-center gap-2"
              >
                <span
                  class="w-6 h-6 bg-purple-100 dark:bg-purple-900/30 text-purple-600 rounded-full flex items-center justify-center text-xs"
                  >2</span
                >
                Icône du produit
              </h4>
              <div class="grid grid-cols-10 gap-2 mb-3">
                @for (icon of productIcons; track icon) {
                  <button
                    (click)="customProduct.productIcon = icon"
                    [class.ring-2]="customProduct.productIcon === icon"
                    [class.ring-green-500]="customProduct.productIcon === icon"
                    [class.bg-green-50]="customProduct.productIcon === icon"
                    class="w-full aspect-square p-2 border-2 border-gray-200 dark:border-slate-700 rounded-lg hover:border-green-300 transition-all text-2xl flex items-center justify-center cursor-pointer"
                  >
                    {{ icon }}
                  </button>
                }
              </div>
              <div class="flex items-center gap-2">
                <input
                  type="text"
                  [(ngModel)]="customProduct.productIcon"
                  placeholder="ou tapez un emoji"
                  maxlength="2"
                  class="flex-1 px-4 py-2 border-2 border-gray-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all text-center text-2xl"
                />
                <span class="text-sm text-gray-500 dark:text-gray-400"
                  >Ou tapez votre emoji</span
                >
              </div>
            </div>
            <!-- Section 3: Quantités et Prix -->
            <div>
              <h4
                class="text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wide mb-4 flex items-center gap-2"
              >
                <span
                  class="w-6 h-6 bg-orange-100 dark:bg-orange-900/30 text-orange-600 rounded-full flex items-center justify-center text-xs"
                  >3</span
                >
                Quantités et tarification
              </h4>
              <div class="grid grid-cols-2 sm:grid-cols-4 gap-4">
                <div>
                  <label
                    class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                    title="Quantité préparée par défaut pour chaque service (R1)"
                  >
                    Stock journalier <span class="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    [(ngModel)]="customProduct.quantity"
                    [min]="1"
                    class="w-full px-4 py-3 border-2 border-gray-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all text-center font-bold text-lg"
                  />
                </div>
                <div>
                  <label
                    class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                  >
                    Unité <span class="text-red-500">*</span>
                  </label>
                  <select
                    [(ngModel)]="customProduct.unit"
                    class="w-full px-4 py-3 border-2 border-gray-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all font-medium"
                  >
                    <option value="unité" selected>unité</option>
                    @for (unit of units; track $index) {
                      <option [value]="unit" [hidden]="unit === 'unité'">
                        {{ unit }}
                      </option>
                    }
                  </select>
                </div>
                <div>
                  <label
                    class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                  >
                    Prix d'achat <span class="text-red-500">*</span>
                  </label>
                  <div class="relative">
                    <input
                      type="number"
                      [(ngModel)]="customProduct.purchasePrice"
                      [min]="0"
                      step="0.1"
                      placeholder="0.00"
                      class="w-full px-4 py-3 pr-8 border-2 border-gray-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all text-center font-bold text-lg"
                    />
                    <span
                      class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-400 font-medium"
                      >€</span
                    >
                  </div>
                </div>
                <div>
                  <label
                    class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                  >
                    Prix de vente <span class="text-red-500">*</span>
                  </label>
                  <div class="relative">
                    <input
                      type="number"
                      [(ngModel)]="customProduct.sellPrice"
                      [min]="0"
                      step="0.1"
                      placeholder="0.00"
                      class="w-full px-4 py-3 pr-8 border-2 border-gray-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all text-center font-bold text-lg"
                    />
                    <span
                      class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-400 font-medium"
                      >€</span
                    >
                  </div>
                </div>
              </div>
              <!-- Marge calculée -->
              @if (
                customProduct.purchasePrice > 0 && customProduct.sellPrice > 0
              ) {
                <div
                  class="mt-3 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800"
                >
                  <div class="flex justify-between items-center text-sm">
                    <span class="text-blue-900 dark:text-blue-300 font-semibold"
                      >Marge:</span
                    >
                    <span
                      class="font-bold text-lg text-blue-700 dark:text-blue-300"
                    >
                      {{
                        ((customProduct.sellPrice -
                          customProduct.purchasePrice) /
                          customProduct.purchasePrice) *
                          100 | number: "1.0-0"
                      }}%
                      <span
                        class="text-sm font-normal text-blue-600 dark:text-blue-400 ml-1"
                      >
                        ({{
                          customProduct.sellPrice - customProduct.purchasePrice
                            | number: "1.2-2"
                        }}€/unité)
                      </span>
                    </span>
                  </div>
                </div>
              }
            </div>

            <!-- Périssabilité -->
            <div class="mt-3">
              <label
                class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
              >
                Périssabilité
              </label>
              <div class="flex gap-2">
                <button
                  type="button"
                  (click)="customProduct.perishability = 'high'"
                  class="flex-1 px-3 py-2 rounded-xl text-xs font-medium border-2 transition-all"
                  [class.border-red-400]="
                    customProduct.perishability === 'high'
                  "
                  [class.bg-red-50]="customProduct.perishability === 'high'"
                  [class.text-red-700]="customProduct.perishability === 'high'"
                  [class.border-gray-200]="
                    customProduct.perishability !== 'high'
                  "
                  [class.text-gray-600]="customProduct.perishability !== 'high'"
                >
                  🥖 Jour même
                </button>
                <button
                  type="button"
                  (click)="customProduct.perishability = 'medium'"
                  class="flex-1 px-3 py-2 rounded-xl text-xs font-medium border-2 transition-all"
                  [class.border-amber-400]="
                    customProduct.perishability === 'medium'
                  "
                  [class.bg-amber-50]="customProduct.perishability === 'medium'"
                  [class.text-amber-700]="
                    customProduct.perishability === 'medium'
                  "
                  [class.border-gray-200]="
                    customProduct.perishability !== 'medium'
                  "
                  [class.text-gray-600]="
                    customProduct.perishability !== 'medium'
                  "
                >
                  ⚠️ 1-2 jours
                </button>
                <button
                  type="button"
                  (click)="customProduct.perishability = 'low'"
                  class="flex-1 px-3 py-2 rounded-xl text-xs font-medium border-2 transition-all"
                  [class.border-sky-400]="customProduct.perishability === 'low'"
                  [class.bg-sky-50]="customProduct.perishability === 'low'"
                  [class.text-sky-700]="customProduct.perishability === 'low'"
                  [class.border-gray-200]="
                    customProduct.perishability !== 'low'
                  "
                  [class.text-gray-600]="customProduct.perishability !== 'low'"
                >
                  🧊 Longue conservation
                </button>
              </div>
              <p class="text-[10px] text-gray-400 mt-1">
                Les invendus non-périssables ne comptent pas comme gaspillage
              </p>
            </div>
          </div>
        </div>
        <!-- Footer (fixe) -->
        <div class="flex-shrink-0 p-6 pt-0">
          <div
            class="flex gap-3 pt-6 border-t-2 border-gray-100 dark:border-slate-700"
          >
            <button
              (click)="closeAddCustomProductModal()"
              class="flex-1 px-6 py-3 bg-gray-100 dark:bg-slate-800 hover:bg-gray-200 dark:hover:bg-slate-600 dark:bg-slate-700 text-gray-700 dark:text-gray-300 rounded-xl font-semibold transition-all"
            >
              Annuler
            </button>
            <button
              (click)="addCustomProduct()"
              [disabled]="!isCustomProductValid()"
              class="flex-1 px-6 py-3 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white rounded-xl font-semibold transition-all disabled:opacity-50 disabled:cursor-not-allowed shadow-lg dark:shadow-slate-900/50 shadow-green-500/30 flex items-center justify-center gap-2"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                ></path>
              </svg>
              Ajouter le produit
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
<!-- End scrollable container -->

<!-- MODAL TEMPLATE PICKER -->
@if (showTemplatePicker) {
  <div
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 animate-fade-in"
    (click)="showTemplatePicker = false"
  >
    <div
      class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] flex flex-col animate-scale-in"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <div
        class="flex-shrink-0 bg-gradient-to-r from-purple-600 to-indigo-600 text-white p-6 rounded-t-2xl"
      >
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div
              class="w-12 h-12 bg-white bg-opacity-20 rounded-xl flex items-center justify-center"
            >
              <span class="text-2xl">📋</span>
            </div>
            <div>
              <h3 class="text-xl font-bold">Partir d'un template</h3>
              <p class="text-sm text-purple-100 mt-1">
                Ajoutez un catalogue pré-configuré adapté à votre activité
              </p>
            </div>
          </div>
          <button
            (click)="showTemplatePicker = false"
            class="w-10 h-10 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-lg transition-all flex items-center justify-center"
          >
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              ></path>
            </svg>
          </button>
        </div>
      </div>
      <!-- Body -->
      <div class="flex-1 overflow-y-auto p-6">
        <app-catalog-template-picker
          [isOnboarding]="isOnboarding()"
          [merchantType]="merchantType()"
          [activityType]="activityType"
          (templateApplied)="onTemplateApplied($event)"
          (close)="showTemplatePicker = false"
        ></app-catalog-template-picker>
      </div>
    </div>
  </div>
}

<!-- CONFIRM DELETE ALL MODAL -->
@if (confirmingDeleteAll) {
  <div
    class="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50"
    (click)="cancelDeleteAll()"
  >
    <div
      class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl p-6 max-w-sm mx-4 animate-scale-in"
      (click)="$event.stopPropagation()"
    >
      <div class="text-center">
        <div
          class="w-14 h-14 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mx-auto mb-4"
        >
          <span class="text-3xl">🗑️</span>
        </div>
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-2">
          Supprimer tous les produits ?
        </h3>
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-6">
          Cette action supprimera vos {{ myProducts.length }} produits. Elle est
          irréversible.
        </p>
        <div class="flex gap-3">
          <button
            (click)="cancelDeleteAll()"
            class="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-slate-700 hover:bg-gray-200 dark:hover:bg-slate-600 rounded-xl transition-colors"
          >
            Annuler
          </button>
          <button
            (click)="confirmDeleteAll()"
            class="flex-1 px-4 py-2.5 text-sm font-bold text-white bg-red-500 hover:bg-red-600 rounded-xl transition-colors shadow-sm"
          >
            Supprimer tout
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- NOTIFICATION TOAST -->
@if (notification) {
  <div
    class="fixed bottom-6 right-6 bg-white dark:bg-slate-800 rounded-lg shadow-lg dark:shadow-slate-900/50 border-l-4 p-4 z-50 animate-slide-up"
    [class.border-green-500]="notification.type === 'success'"
    [class.border-red-500]="notification.type === 'error'"
    [class.border-blue-500]="notification.type === 'info'"
  >
    <p class="font-medium text-gray-900 dark:text-white">
      {{ notification.message }}
    </p>
  </div>
}
